import {
  CommandBarButton,
  DirectionalHint,
  getTheme,
  Icon,
  IDetailsListStyles,
  IOverflowSetItemProps,
  TooltipHost,
} from "@fluentui/react";
import { CSSProp, CSSProperties } from "styled-components";
import { IPagination } from "../../Interfaces/base/ITable";
import { Ifilter } from "../../Interfaces/filter";
import { ConfigHelper } from "./configHelper";

const PersonaImageUrl =
  "http://www.consuladohondurasmadrid.es/wp-content/uploads/2017/05/male-300x300.png";
const baseSearch = "search";
const initialUrl = `${ConfigHelper.urlBase(true)}`;
// const initialUrl = "/ssoma";
const keyJwt = "Jwt";
const keyAccess = "Access";
const baseImageUrl =
  "http://www.consuladohondurasmadrid.es/wp-content/uploads/2017/05/male-300x300.png";

// validación politicas contraseña
const EXPRESION_EMAIL =
  /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
const CONTIENE_NUMERO = /\d/;
const CONTIENE_MINUSCULA = /[a-z]/;
const CONTIENE_MAYUSCULA = /[A-Z]/;
const CONTIENE_NO_ALFANUMERICO = /[^a-zA-Z0-9]/;

/**Fuente general*/
export const helperfontFamily = `-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen','Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',sans-serif`;
/**Fuente general*/
export const helperFont: CSSProperties = {
  fontFamily: helperfontFamily,
  WebkitFontSmoothing: "antialiased",
  MozOsxFontSmoothing: "grayscale",
};

const _initialFilter = () => {
  let d: Ifilter = {
    skip: 0,
    take: 50,
    search: null,
  };

  return d;
};
const theme = getTheme();

export function textoCadaPalabraMayuscula(text: string): string {
  if (!Boolean(text)) {
    return text;
  }
  const palabras = text.toLocaleLowerCase().split(" ");
  if (palabras.length === 0) {
    return text;
  }
  let newText = palabras
    .map((palabra) => {
      return palabra[0].toUpperCase() + palabra.substring(1);
    })
    .join(" ");

  return newText;
}
/* DetailList */
const _onRenderHeader: Partial<IDetailsListStyles> = {
  root: {
    overflowX: "scroll",
    fontFamily: helperfontFamily,
    selectors: {
      "& [role=grid]": {
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        height: "70vh",
      },
    },
  },
  headerWrapper: {
    paddingTop: "0px",
    flex: "0 0 auto",
    margin: "0 0 1px 0",
    boxShadow: theme.effects.elevation8,
  },
  contentWrapper: {
    flex: "1 1 auto",
    overflowY: "auto",
    overflowX: "hidden",
  },
};

const _onRenderHeaderList: Partial<IDetailsListStyles> = {
  root: {
    overflowX: "scroll",
    selectors: {
      "& [role=grid]": {
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        height: "25vh",
      },
    },
    // marginTop:1,
    border: theme.palette.neutralLight,
    borderStyle: "solid",
  },
  headerWrapper: {
    position: "sticky",
    margin: "0 0 1px 0",
    paddingTop: "0px",
    // boxShadow: theme.effects.elevation8,
    // flex: '0 0 auto',
  },
  contentWrapper: {
    // flex: '1 1 auto',
    overflowY: "auto",
    overflowX: "hidden",
  },
};
const _onRenderHeaderAllheight: Partial<IDetailsListStyles> = {
  root: {
    overflowX: "scroll",
    selectors: {
      "& [role=grid]": {
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        height: "calc(100vh - 11.5em)",
      },
    },
  },
  headerWrapper: {
    position: "sticky",
    margin: "0 0 0 0",
    paddingTop: "0px",
    // boxShadow: theme.effects.elevation8,
    // flex: '0 0 auto',
  },
  contentWrapper: {
    // flex: '1 1 auto',
    overflowY: "auto",
    overflowX: "hidden",
  },
};
export function stringToUpperCamelCase(text: string): string {
  const palabras = text.toLocaleLowerCase().split(" ");

  let newText = palabras
    .map((palabra) => {
      return palabra[0].toUpperCase() + palabra.substring(1);
    })
    .join(" ");

  return newText;
}

/* Pagination */
const _initialPagination = () => {
  let t: IPagination = {
    currentPage: 1,
    total: 0,
    pageSize: 50,
  };

  return t;
};

export const onRenderOverflowButton = (
  overflowItems: any[] | undefined
): JSX.Element => {
  return (
    <TooltipHost
      content="Opciones"
      directionalHint={DirectionalHint.rightCenter}>
      <CommandBarButton
        aria-label="More items"
        menuIconProps={{ iconName: "pdf" }}
        // menuIconProps={{ iconName: 'MoreVertical' }}
        menuProps={{ items: overflowItems! }}
        styles={{
          root: { background: "none" },
          menuIcon: { color: "red", fontSize: 16 },
        }}
      />
    </TooltipHost>
  );
};

export const onRenderItem = (item: IOverflowSetItemProps): JSX.Element => {
  return (
    <TooltipHost
      content={item.title}
      directionalHint={DirectionalHint.leftCenter}>
      {/* <CommandBarButton
        aria-label={item.name}
        iconProps={{ iconName: item.icon }}
        onClick={item.onClick}
        styles={{ root: { background: "none" } }}
      /> */}
    </TooltipHost>
  );
};

const usuariosDominios = ["mmg.com"];

const validarDominio = (email) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  // Validar el formato del email
  if (!emailRegex.test(email)) {
    return false;
  }
  // Obtener el dominio del email
  const dominio = email.split("@")[1];
  // Comprobar si el dominio está en la lista de dominios
  if (usuariosDominios.includes(dominio)) {
    return true;
  } else {
    return false;
  }
};

const cambiarUrl = (urlLogin) => {
  let url = urlLogin?.replace("//", "@");
  return url?.replace(/\//g, "!");
};

const RedireccionUrlIdentidad = (
  urlBase: string,
  email: string,
  token: string,
  urlLogin: string
) => {
  const urlRedireccin = `${urlBase}/cambiarContrasenia?email=${email}&token=${token}&urlLogin=${urlLogin}`;
  return urlRedireccin;
};

const RedireccionUrlContraseniaIdentidad = (
  urlBase: string,
  email: string,
  token: string,
  urlLogin: string
) => {
  const urlRedireccion = `${urlBase}/CambiarContraseniaVigencia?email=${email}&token=${token}&urlLogin=${urlLogin}`;
  return urlRedireccion;
};

export {
  initialUrl,
  keyJwt,
  keyAccess,
  _initialFilter,
  _initialPagination,
  baseSearch,
  _onRenderHeader,
  _onRenderHeaderList,
  _onRenderHeaderAllheight,
  PersonaImageUrl,
  baseImageUrl,
  validarDominio,
  EXPRESION_EMAIL,
  CONTIENE_NUMERO,
  CONTIENE_MINUSCULA,
  CONTIENE_MAYUSCULA,
  CONTIENE_NO_ALFANUMERICO,
  cambiarUrl,
  RedireccionUrlIdentidad,
  RedireccionUrlContraseniaIdentidad,
};
